<template>
  <div class="download-box">
    <div>
      <span>插件启动失败，请检查插件是否安装！</span>
      <br/>
      <br/>
      <div>Windows操作系统:</div>
      <el-link href="https://smart-site-pdt.oss-cn-shanghai.aliyuncs.com/pc_static_resource/VideoWebPlugin.exe" target="_blank" type="primary">
        下载安装视频播放插件
      </el-link>
      <br/>
      <!-- <br/>
      <div>国产化麒麟系统(2个插件需一并下载):</div>
      <el-link href="https://smart-site-pdt.oss-cn-shanghai.aliyuncs.com/pc_static_resource/com.hikvision.webbrowserplugin_1.4.200.20240724154333_arm64.deb" target="_blank" type="primary">
        下载安装视频播放插件1
      </el-link>
      <br/>
      <el-button type = "text" @click="dialogVisible = true">下载安装视频播放插件2</el-button> -->

      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
        :append-to-body = "true"
        destroy-on-close :close-on-click-modal="false" center>

        <span>请选择对应cpu架构的插件：（打开终端输入：lscpu显示cpu架构）</span><br/>
        <el-link href="https://smart-site-pdt.oss-cn-shanghai.aliyuncs.com/pc_static_resource/libgles2_1.3.2-1~kylin0.20.04.2_loongarch64.deb" target="_blank" type="primary">
          loongarch64
        </el-link><br/>
        <el-link href="https://smart-site-pdt.oss-cn-shanghai.aliyuncs.com/pc_static_resource/libgles2_1.3.2-1~kylin0.20.04.2_mips64el.deb" target="_blank" type="primary">
          mips64
        </el-link><br/>
        <el-link href="https://smart-site-pdt.oss-cn-shanghai.aliyuncs.com/pc_static_resource/libgles2_1.3.2-1~kylin0.20.04.2_arm64.deb" target="_blank" type="primary">
          aarch64
        </el-link><br/>
        <el-link href="https://smart-site-pdt.oss-cn-shanghai.aliyuncs.com/pc_static_resource/libgles2_1.3.2-1~kylin0.20.04.2_amd64.deb" target="_blank" type="primary">
          x86_64
        </el-link>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>

    </div>
    <div class="btn">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="$emit('close', true)">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.download-box {
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.btn{
  display: flex;
  justify-content: center;
}
</style>
